import qs from "qs";
import store from "@/store";

import axios from "axios";
import { API_BASE_URL } from "@/api/endpoints";
// import store from './store'

const HTTP = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "content-type": "application/json; charset=utf-8",
  },
});

HTTP.interceptors.request.use(function(config) {
    if(localStorage.getItem("user-token")) {
        config.headers["Authorization"] = "Bearer " + localStorage.getItem("user-token");
    }

    return config;
});
 

HTTP.interceptors.response.use(undefined, function(err) {
  return new Promise(function() {
    if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
      // if you ever get an unauthorized, logout the user
      store.dispatch("AUTH_LOGOUT");
      // you can also redirect to /login if needed !
    }
    throw err;
  });
});

export default {
  post(endpoint, data = {}, options = {}) {
    return HTTP.post(endpoint, data, options);
  },
  get(endpoint, data = {}, options = {}) {
    return HTTP.get(endpoint, data, options);
  },
  request(options) {
    return HTTP.request(options);
  },
  stringify(data) {
    return qs.stringify(data);
  },
};
